export const mapSlideToProps = (state) => {
	let loadingState = state.slideLoadingReducer;
	let {activeMapId, activeAnnoDrawer} = state.gammaStateReducer;
	let {slide, slidemap, annotationState, is_dicom} = state.mapsStateReducer[activeMapId] || {};
	let layer = slidemap && slidemap.getLayers().getArray().find(layer => layer.get('drawer') === activeAnnoDrawer);
	return {activeMapId, slide, slidemap, annotationState, layer, is_dicom, loadingState};
};

export const mapDrawStateToProps = (state) => {
	let {activeMapId, activeAnnoDrawer, selectedDrawColor, selectedAnnoWidth, magicToolDataRetrievalOngoing} = state.gammaStateReducer;
	let {slide, slidemap} = state.mapsStateReducer[activeMapId];
	let layer = slidemap && slidemap.getLayers().getArray().find(layer => layer.get('drawer') === activeAnnoDrawer);
	return {activeMapId, selectedDrawColor, selectedAnnoWidth, slide, slidemap, layer, magicToolDataRetrievalOngoing};
}

export const mapAnnotationStateToProps = (state) => {
	let {activeMapId} = state.gammaStateReducer;
    let {slidemap, annotationState} = state.mapsStateReducer[activeMapId] ?? {};
	return {activeMapId, slidemap, ...annotationState};
}

export const mapViewerConfigurationsToProps = (state) => {
	let {viewer_configurations} = state.morpheusSettingReducer;
	return {viewer_configurations};
}

export const mapGridStateToProps = (state) => {
	let {activeMapId} = state.gammaStateReducer;
	let {gridState, displaySetting} = state.mapsStateReducer[activeMapId];
	return {activeMapId, ...gridState, displaySetting};
}

export const mapTileSlideToProps = (state) => {
	let mapsState = state.mapsStateReducer;
	let gammaState = state.gammaStateReducer;
	let {tileMapEnable} = gammaState;
	let {activeMapId} = state.gammaStateReducer;
	let {slide, slidemap} = state.mapsStateReducer[activeMapId] || {};
	return {mapsState, gammaState, tileMapEnable, activeMapId, slide, slidemap};
};

// TODO: [Priyanshu] Common mapStateToProps for all components which give access to mapState in props
